import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Check, Building2, Loader2 } from "lucide-react";
import { PORTALS, modulesOf } from "@/lib/modules";

export function PortalPicker({ value, onChange, testid = "portals" }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="grid sm:grid-cols-2 gap-2" data-testid={`${testid}-picker`}>
      {PORTALS.map((p) => {
        const on = value.includes(p.key);
        return (
          <button type="button" key={p.key} data-testid={`${testid}-${p.key}`} onClick={() => toggle(p.key)}
            className={`flex items-start gap-3 text-left p-3 rounded-lg border transition-colors ${on ? "border-navy bg-navy/5" : "border-nardo-200 hover:border-navy/40"}`}>
            <span className={`mt-0.5 w-5 h-5 shrink-0 rounded flex items-center justify-center ${on ? "bg-navy text-white" : "border border-nardo-300"}`}>{on && <Check className="w-3.5 h-3.5" />}</span>
            <span><span className="block text-sm font-semibold text-navy">{p.label}</span><span className="block text-[11px] text-nardo-500 leading-snug">{p.desc}</span></span>
          </button>
        );
      })}
    </div>
  );
}

const inp = "w-full border-b-2 border-nardo-200 bg-transparent py-2 focus:border-navy outline-none text-base sm:text-sm";
const empty = { school_name: "", email: "", password: "", monthly_cost: "", portals: PORTALS.map((p) => p.key) };

export default function NewSchoolCard({ onCreated }) {
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.portals.length) { toast.error("Elige al menos un portal"); return; }
    setBusy(true);
    try {
      const { portals, ...rest } = f;
      await api.post("/admin/schools", { ...rest, monthly_cost: Number(f.monthly_cost) || 0, modules: modulesOf(portals) });
      toast.success(`Escuela creada. Ya puede entrar con ${f.email}`);
      setF(empty); onCreated?.();
    } catch (err) { toast.error(err.response?.data?.detail || "No se pudo crear"); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="bg-white border border-nardo-200 rounded-md p-6 mb-6 relative" data-testid="new-school-card">
      <div className="absolute top-0 left-0 h-[2px] w-16 bg-navy" />
      <div className="flex items-center gap-2 mb-1"><Building2 className="w-4 h-4 text-navy" /><h2 className="font-display font-semibold text-xl text-navy">Nueva escuela</h2></div>
      <p className="text-sm text-nardo-500 mb-5">Crea el acceso, elige los portales que compró y su costo mensual.</p>
      <div className="grid sm:grid-cols-2 gap-4 mb-5">
        <input data-testid="ns-school" required className={inp} placeholder="Nombre de la escuela" value={f.school_name} onChange={set("school_name")} />
        <input data-testid="ns-cost" type="number" min="0" step="0.01" className={inp} placeholder="Costo mensual (MXN)" value={f.monthly_cost} onChange={set("monthly_cost")} />
        <input data-testid="ns-email" required type="email" className={inp} placeholder="Correo de acceso" value={f.email} onChange={set("email")} />
        <input data-testid="ns-password" required minLength={6} className={inp} placeholder="Contraseña (mín. 6)" value={f.password} onChange={set("password")} />
      </div>
      <div className="text-[10px] uppercase tracking-[0.2em] text-nardo-500 mb-2">Portales contratados</div>
      <PortalPicker value={f.portals} onChange={(portals) => setF({ ...f, portals })} testid="ns-portal" />
      <button data-testid="ns-submit" disabled={busy} className="mt-5 inline-flex items-center gap-2 bg-navy hover:bg-navy-light text-white px-5 py-2.5 rounded-md text-sm font-semibold disabled:opacity-60">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Dar de alta escuela
      </button>
    </form>
  );
}
